<template>
  <div class="jh-page-rule-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content" @touchmove.stop>
          <div class="rule-h1">活动规则</div>
          <p class="rule-p">
            活动入口和权益领取路径：手机银行APP-活动中心-财富晋升计划
          </p>

          <div class="rule-h2">一、活动规则</div>

          <section class="rule-block">
            <div class="rule-h3">（一）礼遇新客</div>
            <div class="rule-h4">1. 活动对象</div>
            <p class="rule-p">活动期间首次开立借记卡一类户客户</p>

            <div class="rule-h4">2. 活动时间</div>
            <p class="rule-p">活动参与时间：2026年4月10日-2026年6月30日</p>
            <p class="rule-p">权益领取时间：2026年5月5日-2026年8月31日</p>

            <div class="rule-h4">3. 活动内容</div>
            <p class="rule-p">
              活动期间首次开立借记卡一类户且开户当月或次月成为本行财富客户/白金客户/黑金客户/私钻客户即可获得1次开宝箱机会，具体客户等级对应抽奖礼品如下，<span
                class="rule-em rule-em--red"
                >礼品</span
              >数量<span class="rule-em rule-em--red">每月</span
              >有限，先到先得，领完为止：
            </p>
            <p class="rule-p">
              (1) 达标财富客户：可随机抽取58元或88元微信立减金一份；
            </p>
            <p class="rule-p">
              (2) 达标白金客户：可随机抽取158元或218元微信立减金一份；
            </p>
            <p class="rule-p">
              (3) 达标黑金客户：可随机抽取318元或388元微信立减金一份；
            </p>
            <p class="rule-p">
              (4) 达标私钻客户：可随机抽取518元或688元微信立减金一份；
            </p>
            <p class="rule-p rule-p--mt">各档位立减金数量如下：</p>
            <table class="rule-table rule-table--tier-gift">
              <colgroup>
                <col class="rule-table__col-side" />
                <col class="rule-table__col-benefit" />
                <col class="rule-table__col-side" />
              </colgroup>
              <thead>
                <tr>
                  <th>开户次月内客户等级</th>
                  <th>权益</th>
                  <th><span class="rule-em rule-em--red">活动期间</span>数量<span class="rule-em rule-em--red">合计（份）</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">财富</td>
                  <td class="rule-table__benefit">58元微信立减金</td>
                  <td>1119</td>
                </tr>
                <tr>
                  <td class="rule-table__benefit">88元微信立减金</td>
                  <td>81</td>
                </tr>
                <tr>
                  <td rowspan="2">白金</td>
                  <td class="rule-table__benefit">158元微信立减金</td>
                  <td>648</td>
                </tr>
                <tr>
                  <td class="rule-table__benefit">218元微信立减金</td>
                  <td>156</td>
                </tr>
                <tr>
                  <td rowspan="2">黑金</td>
                  <td class="rule-table__benefit">318元微信立减金</td>
                  <td>90</td>
                </tr>
                <tr>
                  <td class="rule-table__benefit">388元微信立减金</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td rowspan="2">私钻</td>
                  <td class="rule-table__benefit">518元微信立减金</td>
                  <td>21</td>
                </tr>
                <tr>
                  <td class="rule-table__benefit">688元微信立减金</td>
                  <td>6</td>
                </tr>
              </tbody>
            </table>

            <div class="rule-h4">4. 活动规则</div>
            <p class="rule-p">
              （1）<span class="rule-em rule-em--red">活动期间，</span
              >以上等级奖励只限领取1次，不可重复获取。
            </p>
            <p class="rule-p">
              （2）客户当月等级由系统于次月5日出具结果并判断是否达标，若达标可开启宝箱抽取对应档位的奖品。活动期间权益宝箱只能开启1次，领取资格当月有效，若当月资格未领取，次月将根据当月达标情况重新判断宝箱开启等级。若开户次月5日达标后未操作开启宝箱，系统将持续跟踪下个月的资产等级，并取两个月的最高等级作为最终结果。客户可根据自身情况选择宝箱开启时间，<span class="rule-em rule-em--red">最迟领取和兑换时间为开户月后2个自然月内，超期不予补发。</span>
            </p>
            <p class="rule-p">
              权益领取路径：厦门国际银行APP-活动中心-二季度财富晋升计划
            </p>
            <p class="rule-p rule-p--strong">举例：</p>
            <p class="rule-p rule-p--example">
              客户4月开户，5月5日系统判断显示等级提升为白金，但客户选择不开启宝箱，2026年6月5日系统判断等级较5月5日结果未提升，仍可于<span
                class="rule-em rule-em--red"
                >6月5日至6月30日期间</span
              >抽取白金等级礼品。
            </p>
            <p class="rule-p rule-p--example">
              客户4月开户，5月5日系统判断显示等级提升为白金，可于<span
                class="rule-em rule-em--red"
                >5月5日至5月31日</span
              >抽取白金等级礼品，抽取完毕后，若6月5日等级进一步提升为黑金，也不可再抽取黑金对应礼品。
            </p>
            <p class="rule-p rule-p--example">
              客户4月开户，5月5日系统判断显示等级提升为白金，但客户选择不开启宝箱，待2026年6月5日系统判断等级进一步提升至黑金后开启宝箱，可于6月5日<span
                class="rule-em rule-em--red"
                >至6月30日期间</span
              >抽取黑金对应礼品。
            </p>
          </section>

          <section class="rule-block">
            <div class="rule-h3">（二）财富进阶</div>
            <div class="rule-h4">1、活动对象</div>
            <p class="rule-p">
              2026年4月1日前开立借记卡一类户的客户
            </p>
            <div class="rule-h4">2、活动时间</div>
            <p class="rule-p">（1）活动报名时间：2026年4月10日-2026年6月30日</p>
            <p class="rule-p">（2）权益领取时间：</p>
            <p class="rule-p">
              4月达标客户（2026年4月30日前报名）可于2026年5月5日-5月31日领取，超期未领不予补发；
            </p>
            <p class="rule-p">
              5月达标客户（2026年5月31日前报名）可于2026年6月5日-6月30日领取，超期未领不予补发；
            </p>
            <p class="rule-p">
              6月达标客户（2026年6月30日前报名）可于2026年7月5日-7月31日领取，超期未领不予补发。
            </p>
            <div class="rule-h4">3、活动内容</div>
            <p class="rule-p">
              客户在活动当月进入活动页面完成报名，且4、5、6月月综合贡献值较上月提升达相应档位，即有机会领取对应奖励。<span
                class="rule-em rule-em--red"
                >每月礼品数量有限，先到先得，领完为止</span
              >。各档位奖品不可重复获取。具体档位及奖励如下：
            </p>
            <p class="rule-p">
              （1）第1档可在以下权益三选一：25元微信立减金、25元京东e卡、1288积分商城积分，<span
                class="rule-em rule-em--red"
                >共4029份</span
              >。
            </p>
            <p class="rule-p">
              （2）第2档可在以下权益三选一：60元微信立减金、60元京东e卡、3088积分商城积分，<span
                class="rule-em rule-em--red"
                >共1032份</span
              >。
            </p>
            <p class="rule-p">
              （3）第3档可在以下权益三选一：80元微信立减金、80元京东e卡、4088积分商城积分，<span
                class="rule-em rule-em--red"
                >共1011份</span
              >。
            </p>
            <p class="rule-p">
              （4）第4档可在以下权益三选一：120元微信立减金、120元京东e卡、6088积分商城积分，<span
                class="rule-em rule-em--red"
                >共222份</span
              >。
            </p>
            <p class="rule-p">
              （5）第5档可在以下权益三选一：200元微信立减金、200元京东e卡、10088积分商城积分，<span
                class="rule-em rule-em--red"
                >共132份</span
              >。
            </p>
            <p class="rule-p">
              （6）第6档可在以下权益三选一：400元微信立减金、400元京东e卡、20088积分商城积分，<span
                class="rule-em rule-em--red"
                >共96份</span
              >。
            </p>
            <p class="rule-p rule-p--strong">注：</p>
            <p class="rule-p rule-p--note">
              （1）活动期间每个报名客户每月最多领取1次，活动期间最多领取3次。
            </p>
            <p class="rule-p rule-p--note">
              （2）综合贡献值计算规则：Σ客户当月每日金融资产/当月总天数。
            </p>
            <p class="rule-p rule-p--note">
              （3）具体综合贡献值档位标准请咨询您的专属客户经理或拨打我行客服热线。
            </p>
            <p class="rule-p rule-p--note">
              （4）权益领取路径：厦门国际银行APP-活动中心-二季度财富晋升计划
            </p>
          </section>

          <section class="rule-block">
            <div class="rule-h3">（三）重归白金礼</div>
            <div class="rule-h4">1、活动对象</div>
            <p class="rule-p">
              2025年年末为白金等级，且2026年1月至3月等级均为白金以下等级的客户。
            </p>
            <div class="rule-h4">2、活动时间</div>
            <p class="rule-p">活动参与时间：2026年4月24日-2026年6月30日</p>
            <p class="rule-p">权益领取时间：2026年5月5日-2026年7月31日</p>
            <div class="rule-h4">3、活动规则</div>
            <p class="rule-p">
              2026年4月至6月任一月，客户等级升级为白金或以上等级，即有机会领取实物礼品一份（以下权益三选一），礼品共500份，<span
                class="rule-em rule-em--red"
                >每月限量150份，当月未领取完毕，自动延续至下月，</span
              >先到先得<span class="rule-em rule-em--red">，领完即止</span>。
            </p>
            <p class="rule-p">权益1：COSTA 弹跳保温杯350ml</p>
            <p class="rule-p">权益2：金龙鱼御品黄金产地稻花香5KG</p>
            <p class="rule-p">
              权益3：潘婷3分钟奇迹臻养洗发水300g+多效修护损伤护发素180ml
            </p>
            <p class="rule-p rule-p--strong">领取须知：</p>
            <p class="rule-p rule-p--note">
              （1）获奖客户需在活动页面选择心仪的实物权益，并填写有效的收货信息。
            </p>
            <p class="rule-p rule-p--note">
              （2）奖品将在客户填写信息后，于5个工作日内安排寄出。
            </p>
            <p class="rule-p rule-p--note">
              （3）活动期间，每位符合资格的客户仅可领取一次奖励。
            </p>
          </section>

          <div class="rule-h2">二、VIP会员判断标准</div>
          <section class="rule-block">
            <p class="rule-p">
              我行将于每月5日前根据您上个月的月日均综合贡献值对您的客户等级进行调整，包括维持、提升或降低。综合贡献值达标情况可登录我行手机银行APP查询或详询您的专属客户经理或支行网点。
            </p>
            <p class="rule-p">等级要求如下：</p>
            <p class="rule-p">(1) 私钻客户：综合贡献值达3000000（含）以上</p>
            <p class="rule-p">
              (2) 黑金客户：综合贡献值达1000000（含）-3000000（不含）
            </p>
            <p class="rule-p">
              (3) 白金客户：综合贡献值达300000（含）-1000000（不含）
            </p>
            <p class="rule-p">
              (4) 星级客户：综合贡献值达10000（含）-300000（不含）
            </p>
            <p class="rule-p rule-p--note">
              权益领取路径：厦门国际银行APP-活动中心-二季度财富晋升计划
            </p>
          </section>

          <div class="rule-h2">三、权益使用说明</div>

          <section class="rule-block">
            <div class="rule-h3">（一）微信立减金</div>
            <p class="rule-p rule-p--note">
              1、微信立减金领取后10天有效，有效期以微信卡包显示为准，过期不补。
            </p>
            <p class="rule-p rule-p--note">
              2、使用厦门国际银行借记卡进行微信支付满足立减金消费门槛自动抵扣，具体使用范围以实际抵扣为准。
            </p>
            <p class="rule-p rule-p--note">
              3、享受优惠的订单，如发生全额退款，且立减金仍在有效期内，立减金将自动退还给用户。如发生部分退款，用户支付金额将按比例原路退还，立减金将按比例退还给用户，用户可继续使用。如立减金已过期，则不退还给用户。
            </p>
            <p class="rule-p rule-p--note">
              4、立减金仅限商业支付时使用，社交支付（如转账、红包、个人收款码支付等）不可用。不可使用商户：肯德基、必胜客、CoCo奶茶、Five Plus、Miss Sixty、ochirly、CovenGarden、Denham、孩子王、热风、太平鸟、优衣库、广东电信、星巴克、珠海城建、航联、微众银行、分付、零钱通、理财通、信用卡还款、腾安基金、哔哩哔哩、华为商城、北京市医院管理中心等。合单支付（微信支付订单号为44开头的交易）无法使用立减金；中国境外商户无法使用立减金。
            </p>
            <p class="rule-p rule-p--note">
              5、本券不找零，不可兑换为现金，不可转让，优惠金额部分不开具发票。
            </p>
            <p class="rule-p rule-p--note">
              6、同一微信号、同一手机号、同一身份证号、同一设备号等，符合其中任意条件视为同一用户。
            </p>
          </section>

          <section class="rule-block">
            <div class="rule-h3">（二）京东E卡</div>
            <p class="rule-p rule-p--note">1、打开京东APP，右下角点击“我的”。</p>
            <p class="rule-p rule-p--note">2、打开我的钱包，点击“礼品卡”。</p>
            <p class="rule-p rule-p--note">3、点击右下角“绑定新卡”。</p>
            <p class="rule-p rule-p--note">4、输入卡密绑定，输入卡密即可查询余额或者绑定。</p>
            <p class="rule-p rule-p--note">5、绑定之后回到主界面即可看到账户已经有了一张e卡。</p>
            <p class="rule-p rule-p--note">6、京东e卡只能用来购买自营商品。</p>
            <p class="rule-p rule-p--note">
              7、在下单时选择自营商品，即可在结算界面看到礼品卡处出现“可用”字样，点击使用即可抵扣金额。
            </p>
          </section>

          <div class="rule-h2">四、温馨提示</div>
          <section class="rule-block">
            <p class="rule-p rule-p--note">
              （一）参与默认规则：参与活动即视为同意活动规则，提醒参与者提前仔细阅读。
            </p>
            <p class="rule-p rule-p--note">
              （二）免责声明：因客户操作不当或网络、运营商故障等非银行可控原因致无法参与活动，我行不予负责。
            </p>
            <p class="rule-p rule-p--note">
              （三）规则变动权：银行可依活动实际情况，在法律允许范围内变动调整活动规则，并通过手机银行客户端、银行公众号公布，公布后即时生效。
            </p>
            <p class="rule-p rule-p--note">
              （四）支持与客服：本活动由易点生活电子商务有限公司支持。领取有问题工作日9:00-21:00拨打400-662-7299；其他疑问每日8:30-20:00拨打厦门国际银行客服热线956085。
            </p>
          </section>
        </div>
        <div class="close-btn" @click="onClose">
          <img src="@/assets/imgs/xibReturnGift/rule_close.png" alt="关闭" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "JhPageRuleModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.jh-page-rule-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    height: 100%;
    max-height: 100dvh;
    box-sizing: border-box;
    padding: 20px 0 28px;
    overflow: hidden;
  }

  .content {
    background: #fff;
    border-radius: 18px;
    padding: 20px 18px 22px;
    box-sizing: border-box;
    color: #1a1a1a;
    width: 88%;
    max-width: 360px;
    margin: 0 auto;
    flex: 0 1 auto;
    min-height: 0;
    max-height: min(60vh, calc(100dvh - 120px));
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    touch-action: pan-y;
    position: relative;
    z-index: 1;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }

  .rule-h1 {
    font-size: 18px;
    font-weight: 700;
    color: #111;
    text-align: center;
    margin-bottom: 12px;
  }

  .rule-h2 {
    font-size: 16px;
    font-weight: 700;
    color: #111;
    margin: 18px 0 10px;
    line-height: 1.35;

    &:first-of-type {
      margin-top: 0;
    }
  }

  .rule-block {
    margin-bottom: 4px;
  }

  .rule-h3 {
    font-size: 15px;
    font-weight: 700;
    color: #111;
    margin: 14px 0 8px;
    line-height: 1.4;
  }

  .rule-h4 {
    font-size: 14px;
    font-weight: 600;
    color: #222;
    margin: 12px 0 6px;
    line-height: 1.4;
  }

  .rule-p {
    margin: 0 0 8px;
    font-size: 12px;
    line-height: 1.65;
    color: #333;
    text-align: justify;

    &--mt {
      margin-top: 4px;
    }

    &--strong {
      font-weight: 600;
      color: #222;
    }

    /* Word 文档中「举例」三条为加粗正文 */
    &--example {
      font-weight: 600;
      color: #222;
    }

    /* Word 文档中「注」下（1）～（4）为加粗 */
    &--note {
      font-weight: 600;
      color: #222;
    }
  }

  /* Word：标红 FF0000 */
  .rule-em {
    font-weight: inherit;

    &--red {
      color: #ff0000;
    }
  }

  .rule-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
    margin: 8px 0 14px;
    color: #333;

    th,
    td {
      border: 1px solid #ddd;
      padding: 6px 4px;
      text-align: center;
      vertical-align: middle;
    }

    th {
      background: #f5f5f5;
      font-weight: 600;
    }

    &--tier-gift {
      table-layout: fixed;

      .rule-table__col-side {
        width: 25%;
      }

      th:first-child,
      th:last-child,
      td[rowspan],
      td:last-child {
        padding: 4px 2px;
        line-height: 1.3;
      }

      th:first-child,
      th:last-child {
        font-size: 10px;
      }

      .rule-table__benefit {
        white-space: nowrap;
        padding: 4px 2px;
      }
    }
  }

  .close-btn {
    margin-top: 35px;
    width: 28px;
    height: 28px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>
